import React, { useEffect } from 'react';
import { getElementToolbar } from '@starflow/app/extension';
import { useProjectState, useElement, useTempState, setTempState } from '@starflow/app/store';

const ToolbarInner = React.memo(({ elementId, isEditing, isExactlySelected, Toolbar }) => {
  const element = useElement(elementId);

  if (!element) return null;

  return <Toolbar element={element} isEditing={isEditing} isExactlySelected={isExactlySelected} />;
});

export const Toolbar = () => {
  const editingElementId = useProjectState('editingElementId');
  const selection = useProjectState('selection');
  const TempToolbar = useTempState('tempToolbarElement');

  if (TempToolbar) {
    return (
      <div
        id="top-toolbars-wrapper"
        className="absolute top-16 left-0 w-screen flex justify-center empty:hidden pointer-events-none"
      >
        <div className="flex items-center h-[34px] px-[8px] shadow-light bg-white rounded-sm">
          <TempToolbar />
        </div>
      </div>
    );
  }

  if (!editingElementId && selection.length !== 1) return null;

  // TODO 留意一下，后续可能会有选中多元素后的工具栏
  const elementId = editingElementId || selection[0];
  if (!elementId) return null;

  const Toolbar = getElementToolbar(elementId.split('-')[1]);
  if (!Toolbar) return null;

  const isEditing = editingElementId === elementId;
  const isExactlySelected = selection.length === 1 && selection[0] === elementId;

  return (
    <div
      id="top-toolbars-wrapper"
      className="absolute top-16 left-0 w-screen flex justify-center empty:hidden pointer-events-none"
    >
      <div className="flex items-center h-[34px] px-[8px] shadow-light bg-white rounded-sm empty:hidden">
        <ToolbarInner
          Toolbar={Toolbar}
          elementId={elementId}
          isEditing={isEditing}
          isExactlySelected={isExactlySelected}
        />
      </div>
    </div>
  );
};
